import { useState, useEffect } from 'react';
import { Button } from '@a-ui/react';
import { useSelector, useDispatch  } from 'react-redux'
import { stopTask, fetchTask } from '../../../store/slices/tasksReducer'
import { closeModal } from '../../../store/slices/modalReducer'
import { fetchTasks } from '../../../store/slices/tasksReducer'
import { getTaskTypesMotivationsForDomain } from '../../../store/slices/domainsReducer'

const CancelTask = (props) => {

  const [loading, setloading]  = useState(false);
  const [note, setNote]  = useState("");
  const [motivations, setMotivations]  = useState([]);
  const { selectedTask, data } = useSelector(state => state.tasks);
  const task = data.find((task) => task.id === selectedTask);
  const { taskTypesMotivations } = useSelector(state => state.domains);
  const suggestedMotivations = taskTypesMotivations?.suggestedMotivations?.filter(({ category }) => category === "abort") || [];

  const dispatch = useDispatch();
  useEffect(() => {
    if(task) {
      dispatch(getTaskTypesMotivationsForDomain({
        domainId: task.domainId,
        tasktypeId: task.taskTypeId,
      }));
    }
  }, [task, dispatch]);

  let requiredComment = true;
  if (suggestedMotivations?.length > 0)requiredComment = false;

  return <>
    <div className="row">
      <div className="col-xs-12 u-margin-bottom-xss">
        <div className="a-input">
          <label className="a-input__label"><strong>Taak afgebroken door</strong></label>
          {
            suggestedMotivations?.map((motivation, i) => {
              return <div className="a-input__checkbox">
                <input type="checkbox" id={`checkbox${i}`} name="input-checkbox" onChange={(e) => {
                  if (e.currentTarget.checked) {
                    setMotivations([
                      ...motivations,
                      { answer: motivation.answer, businessIdentifier: motivation.businessIdentifier },
                    ])
                  } else {
                    setMotivations(
                      motivations.filter((m) => {
                        if(m.answer === motivation.answer) return false;
                        return true;
                      })
                    )
                  }
                }} />
              <label htmlFor={`checkbox${i}`}>{motivation.answer}</label>
            </div>
            })
          }
          <div className="a-input is-required u-margin-top">
            <label className="a-input__label" htmlFor="input-textarea">Extra informatie{ requiredComment && <span className="u-text-danger">*</span>}</label>
            <textarea rows="4" name="input-textarea" id="input-textarea" onChange={(e) => setNote(e.target.value)} ></textarea>
            <small aria-live="polite" className="a-input__description u-text-right">{note.length} / 200</small>
          </div>
        </div>
      </div>
      <div className="col-xs-12">
        <Button
          className={`${loading && "has-icon-right"} a-button` }
          type="danger"
          size="medium"
          disabled={(!requiredComment && motivations.length === 0) || (requiredComment && note.length === 0)}
          onClick={() => {
            setloading(true);
            dispatch(stopTask({
              taskId: selectedTask,
              motivations,
              note,
            })).then(() => {
              dispatch(fetchTasks())
              dispatch(fetchTask(selectedTask));
              dispatch(closeModal(true));
            })
          }}
        >
          { loading && <span className="a-spinner a-spinner--xs" role="alert">
            <span className="a-spinner__circle">
              <span className="u-screen-reader-only">Loading...</span>
            </span>
          </span> }
          Taak afbreken
        </Button>
        <Button
          emphasis="low"
          onClick={() => {
            dispatch(closeModal(false))
          }}
        >
          Annuleren
        </Button>
      </div>
    </div>
  </>

}

export default CancelTask;
